/* eslint-disable */
export default {
  mute: 'Disatt. audio',
  unmute: 'Riattiva audio',
  hangup: 'Riaggancia',
  reject: 'Rifiuta',
  hold: 'Metti in attesa',
  onHold: 'In attesa',
  transfer: 'Trasferisci',
  more: 'Altro',
  stopRecord: 'Interrompi registrazione',
  record: 'Registra',
  showKeypad: 'Tastiera',
  hideKeypad: 'Nascondi tastiera',
  unHold: "Interrompi l'attesa",
  forward: 'Inoltra',
  ignore: 'Ignora',
  voicemail: 'Alla segreteria telefonica',
  custom: 'Personalizza',
  answerAndEnd: 'Rispondi e termina',
  answerAndHold: 'Rispondi e attesa',
  answer: 'Rispondi',
  completeTransfer: 'Completa trasferimento',
  reply: 'Rispondi',
  add: 'Aggiungi',
  mergeCall: 'Unisci a chiamata attiva',
  endCallForEveryone: 'Termina la chiamata per tutti',
  leaveCall: 'Esci dalla chiamata',
  leaveOrEndCall: 'Abbandonare o terminare la chiamata?',
} as const;

// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"more"@#@ @source: @#@"More"@#@
// @key: @#@"stopRecord"@#@ @source: @#@"Stop Recording"@#@
// @key: @#@"record"@#@ @source: @#@"Record"@#@
// @key: @#@"showKeypad"@#@ @source: @#@"Keypad"@#@
// @key: @#@"hideKeypad"@#@ @source: @#@"Hide Keypad"@#@
// @key: @#@"unHold"@#@ @source: @#@"Unhold"@#@
// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"voicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"custom"@#@ @source: @#@"Custom"@#@
// @key: @#@"answerAndEnd"@#@ @source: @#@"Answer & End"@#@
// @key: @#@"answerAndHold"@#@ @source: @#@"Answer & Hold"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"completeTransfer"@#@ @source: @#@"Complete transfer"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"mergeCall"@#@ @source: @#@"Merge with active call"@#@
// @key: @#@"endCallForEveryone"@#@ @source: @#@"End call for everyone"@#@
// @key: @#@"leaveCall"@#@ @source: @#@"Leave call"@#@
// @key: @#@"leaveOrEndCall"@#@ @source: @#@"Leave or end call?"@#@
